<template>
  <div
    class="theme-tabar-item"
    :class="isActive ? 'theme-tabbar-item-active' : ''"
    :style="newStyle"
    @click="clickItem"
    v-bind="$attrs"
  >
    <BaseIconSvg class="icon-class" :type="props.icon" :size="props.iconSize" v-if="props.icon !== ''" />
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
  import { ref, watchEffect } from 'vue';
  import { useTheme } from '@shared/components/theme-components/use-theme';
  import { BaseIconSvg } from '@shared/components';
  import { computed } from '@vue/reactivity';
  import { useRouter, useRoute } from 'vue-router';

  interface Props {
    icon?: string;
    active?: boolean;
    path?: string;
    iconSize?: number;
  }

  const props = withDefaults(defineProps<Props>(), {
    icon: '',
    active: false,
    path: '',
    iconSize: 22,
  });

  const newStyle = ref({});

  const handlerStyle = () => {
    const newthemeStyle = useTheme('tabbar');

    newStyle.value = { ...newthemeStyle };
  };

  const emit = defineEmits<{
    (e: 'doclick'): void;
  }>();

  const router = useRouter();
  const route = useRoute();
  const clickItem = () => {
    props.path && router.push({ path: props.path, query: route.query });
    emit('doclick');
  };

  const isActive = computed(() => {
    const path = props.path && route.path === props.path;
    return path || props.active;
  });

  watchEffect(() => {
    handlerStyle();
  });
</script>

<style scoped lang="less">
  .theme-tabar-item {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 2px;
    color: #999;
    text-align: center;
    background-color: #fff;

    .icon-class {
      color: #999;
    }

    &.theme-tabbar-item-active {
      color: var(--activeTitleColor);

      .icon-class {
        color: var(--activeIconColor) !important;
      }
    }
  }
</style>
